<div class="dialog-padding">
  <h1 class="title" mat-dialog-title id="addOrganizationRiderDialog-title-addOrganization">Add Organization</h1>
  <form [formGroup]="addOrganizationRiderForm" (ngSubmit)="handleSubmission()" id="addOrganizationRiderDialog-form-addOrganization">
    <div class="organization-fields">
      <div class="customerID-and-organization">
        <!-- Organization -->
        <div>
          <uz-organization-select
            class="organization"
            formControlName="organization"
            (selectOrganization)="handleOrganizationSelected($event)"
          >
          </uz-organization-select>
          <p class="text-danger" *ngIf="hasDuplicateOrganizations">A rider cannot be linked to the same organization multiple times</p>
        </div>

        <!-- Customer ID/Partner Identifier -->
        <ng-container *ngIf="!addOrganizationRiderForm.controls.organization.value?.partnerIdentifierAutoGenerated; else autoGeneratedPartnerIdentifier">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="customerID">
          <mat-label>Customer ID</mat-label>
          <input
            id="addOrganizationRiderDialog-input-customerId"
            matInput
            placeholder="Customer ID"
            formControlName="partnerIdentifier"
            data-private
          />
          <mat-error *ngIf="addOrganizationRiderForm.get('partnerIdentifier')?.errors"> No special characters </mat-error>
        </mat-form-field>
        </ng-container>

        <!-- Auto-generated Partner Identifier -->
        <ng-template #autoGeneratedPartnerIdentifier>
          <div>
            <small>Customer ID</small>
            <p id="addOrganizationRiderDialog-text-autoGeneratedPartnerIdentifier">Automatically generated upon save</p>
          </div>
        </ng-template>
      </div>
      <div *ngFor="let organizationServiceLevel of organizationServiceLevels" class="service-level-subscript">
        <p *ngIf="!organizationServiceLevel.optional" class="service-level-subscript">
          * {{ organizationServiceLevel.serviceLevel.name }} service is always offered
        </p>
      </div>

      <div
        class="service-level-options"
        formArrayName="riderServiceLevelsFormArray"
        id="addOrganizationRiderDialog-div-serviceLevelOptions"
      >
        <ng-container *ngFor="let serviceLevel of riderServiceLevelsFormArray.controls; let i = index">
          <div [formGroupName]="i">
            <p>Is the rider <em>always</em> OK with {{ serviceLevel.get('serviceLevel').value.name }} for this organization?</p>
            <mat-radio-group
              formControlName="enabled"
              (change)="changeServiceLevel(i, $event)"
              [id]="'addOrganizationRiderDialog-radioGroup-serviceLevel' + i"
            >
              <mat-radio-button [value]="true" [id]="'addOrganizationRiderDialog-radioButton-serviceLevelYes' + i">
                Yes, the rider is <em>always</em> OK with {{ serviceLevel.get('serviceLevel').value.name }}
              </mat-radio-button>
              <br />
              <mat-radio-button [value]="false" [id]="'addOrganizationRiderDialog-radioButton-serviceLevelNo' + i">
                No, the rider is not <em>always</em> OK with {{ serviceLevel.get('serviceLevel').value.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </ng-container>
      </div>

      <!-- Rider Pool -->
      <ng-container *ngIf="shouldShowOrganizationRiderPoolSelection(addOrganizationRiderForm.controls.organization?.value?.id)">
        <mat-form-field appearance="outline" class="organization-rider-pool">
          <mat-label>Rider Pool</mat-label>
          <mat-select
            id="addOrganizationRider-select-riderPool-{{ addOrganizationRiderForm.controls.organization?.value?.code }}"
            formControlName="organizationRiderPool"
            placeholder="Rider Pool"
          >
            <mat-option
              id="addOrganizationRider-option-{{ organizationRiderPool?.code | camelCase }}"
              *ngFor="let organizationRiderPool of organizationRiderPools"
              [value]="organizationRiderPool"
            >
              {{ getOrganizationRiderPoolDisplayText(organizationRiderPool) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <!-- First Name -->
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input id="addOrganizationRiderDialog-input-firstName" matInput placeholder="First Name" formControlName="firstName" />
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input id="addOrganizationRiderDialog-input-lastName" matInput placeholder="Last Name" formControlName="lastName" />
      </mat-form-field>

      <!-- Email Address -->
      <mat-form-field appearance="outline">
        <mat-label>Email Address</mat-label>
        <input id="addOrganizationRiderDialog-input-email" matInput placeholder="Email Address" formControlName="emailAddress" />
      </mat-form-field>

      <!-- Phone Number -->
      <mat-form-field appearance="outline">
        <mat-label>Phone Number</mat-label>
        <input
          id="addOrganizationRiderDialog-input-phoneNumber"
          matInput
          placeholder="Phone Number"
          formControlName="phoneNumber"
          uzPhoneNumberInput
          data-private="lipsum"
        />
      </mat-form-field>

      <!-- Date of Birth -->
      <mat-form-field appearance="outline">
        <mat-label>Date of Birth</mat-label>
        <input
          id="addOrganizationRiderDialog-input-dateOfBirth"
          matInput
          [matDatepicker]="picker"
          name="dateOfBirth"
          formControlName="dateOfBirth"
        />
        <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-dialog-actions align="end">
        <button id="addOrganizationRiderDialog-button-cancel" mat-raised-button mat-dialog-close>Cancel</button>
        <button
          id="addOrganizationRiderDialog-button-save"
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="addOrganizationRiderForm.invalid"
        >
          Save
        </button>
      </mat-dialog-actions>
    </div>
  </form>
</div>
